import axios from "@/axios/";
import user from "@/api/user";
import links from "@/api/links";

export default {
  user: user(axios),
  links: links(axios),
};
